const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the Semantic Multi Select component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */

app.directive('suMultiSelect', [function () {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      options: '=',
      selected: '=',
      dropName: '@',
      viewRestricted: '@?',
      restrictedSelections: '='
    },
    template: require('../../templates/directives/su-multi-select.html'),
    link: function (scope, element, attrs) {
      scope.multi = {
        selections: {},
        menuClick: function() {
          if (this.open) {
            return;
          }
          this.open = true;
          this.openBlock = {'display': 'block'};
        },
        iconClick: function(e) {
          e.stopPropagation();
          this.open = !this.open;
          this.openBlock = this.open ? {'display': 'block'} : '';
        },
        selectItem: function(item) {
          if (initSelect) {
            initSelect();
          }
          this.selections[item.value] = item;
        },
        removeItem: function(value) {
          if (initSelect) {
            initSelect();
          }
          delete this.selections[value];
        },
        restrictLock: function(value) {
          if (scope.restrict) {
            const match = scope.options.filter(option => {
              option.value === value;
            });
            if (!match) {
              return true;
            }
          }
          return false;
        }
      };

      var setSelections = function() {
        var directory = {};
        // exit if no options for some reason
        if(!scope.options) {
          return;
        }
        for (var i = 0; i < scope.options.length; i++) {
          directory[scope.options[i].value] = scope.options[i];
        }
        if (!scope.selected) {
          return;
        }
        for (var i = 0; i < scope.selected.length; i++) {
          scope.multi.selections[scope.selected[i]] = directory[scope.selected[i]];
        }
      };

      

      scope.$watch('multi.selections', function(newVal, oldVal) {
        if (!newVal || newVal === oldVal) {
          return;
        }
        scope.selected = [];

        for (var value in scope.multi.selections) {
          scope.selected.push(value);
        }
      }, true);

      var init = scope.$watch('options', function(newVal, oldVal) {
        if (!newVal || newVal === oldVal) {
          return;
        }

        if (oldVal) {
          return;
        }
        setSelections();
        init();
      });

      var initSelect = scope.$watch('selected', function(newVal, oldVal) {
        if (!newVal || newVal === oldVal) {
          return;
        }

        if (oldVal) {
          return;
        }
        setSelections();
        initSelect();
      });

      if (scope.options) {
        setSelections();
      }
    }
  }
}]);
